import React, { useState } from 'react';
import ExportDynamoDBTable from '../../utils/export';
import { Amplify } from "aws-amplify";
import {
  Authenticator,
} from "@aws-amplify/ui-react";
import { Box, Text } from "theme-ui";
import NavBar from "../../shared/nav-bar";
import { formFields, components } from "../../utils/authentication";
import {
  Heading,
  Button as LumosButton,
 } from "@loanpal/lumos__core";

 import awsExports from "../../aws-exports";
Amplify.configure(awsExports);

const EXPORT_TABLES = [
  {
    label: "Prod — SharedApp",
    value: "SharedApp-ddrj5opqljgbtnn5p4d2i7d25i-prod",
  },
  {
    label: "Prod — Requests",
    value: "Requests-ddrj5opqljgbtnn5p4d2i7d25i-prod",
  },
  {
    label: "Dev — SharedApp",
    value: "SharedApp-4he23jw7efc3vo3bspj27imobi-dev",
  },
  {
    label: "Dev — Requests",
    value: "Requests-4he23jw7efc3vo3bspj27imobi-dev",
  },
];

const sharedAppTableForSelection = (tableName) => {
  const isDev = tableName.includes("-dev");
  return (
    EXPORT_TABLES.find(
      (t) =>
        t.value.startsWith("SharedApp-") &&
        (isDev ? t.value.includes("-dev") : t.value.includes("-prod"))
    )?.value ?? EXPORT_TABLES[0].value
  );
};

const App = () => {
  const [tableName, setTableName] = useState(EXPORT_TABLES[1].value);
  const sharedAppTableName = sharedAppTableForSelection(tableName);

  return (
<Authenticator
      formFields={formFields}
      components={components}
      hideSignUp={true}
    >
      {({ signOut }) => (
        <>
          <NavBar>
            <LumosButton onClick={signOut} style={styles.signOut}>
              Sign out
            </LumosButton>
          </NavBar>
          <div style={styles.container}>
            <Box>
              <Heading
                sx={{                  
                  marginTop: "20px",
                  fontSize: "18px",
                }}
              >
                Export DynamoDB table
              </Heading>
              <Box sx={{ mt: 3, mb: 3, maxWidth: 480 }}>
                <Text
                  as="label"
                  htmlFor="export-table-select"
                  sx={{ display: "block", mb: 2, fontWeight: 600 }}
                >
                  Table to export
                </Text>
                <select
                  id="export-table-select"
                  value={tableName}
                  onChange={(e) => setTableName(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    boxSizing: "border-box",
                  }}
                >
                  {EXPORT_TABLES.map(({ label, value }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </Box>
              <ExportDynamoDBTable
                tableName={tableName}
                sharedAppTableName={sharedAppTableName}
              />
            </Box>
            </div>
        </>
    )}
    </Authenticator>
  );
};

const styles = {
  container: {
    width: "100%",
    maxWidth: 1400,
    margin: "30px",
    padding: "0 16px",
    boxSizing: "border-box",
  },
};

export default App;